module.exports = __webpack_public_path__ + "static/media/my_book_login.30625f1e.PNG";